import { MetaData } from '../../types/meta-data'

interface IMetadataProps {
  country: string
  type:
    | 'homepage'
    | 'experience'
    | 'storefront'
    | 'gift-cards'
    | 'search'
    | 'privacy-policy'
    | 'terms-and-conditions'
  category?: string
  retailer?: string
}

export const getDefaultNationalMetaData = ({
  country,
  type,
  category,
  retailer,
}: IMetadataProps): MetaData => {
  switch (type) {
    case 'homepage':
      return {
        title: `Westfield ${country} - Visit Our Centres or Browse Online`,
        description:
          'Westfield is your one-stop destination for shopping, leisure and entertainment. Discover 1000s of popular retailers in fashion, home, decor and more.',
      }
    case 'experience':
      return {
        title: `Westfield ${country} | ${category}`,
        description: `Westfield is home to your favourite ${category} products. Explore our range of ${category} products, categories, brands, events & offers.`,
      }
    case 'storefront':
      return {
        title: `Westfield ${country} | ${retailer}`,
        description: `${retailer} at Westfield - Shop online and explore ${retailer}’s range of products and categories. Find 100s of quality retailers at your local Westfield
`,
      }
    case 'gift-cards':
      return {
        title: `Westfield Gift Cards - Check Card Balance, Buy Gift Cards`,
        description: `Westfield Gift Cards opens doors to 8000+ shopping experiences in Westfield Centres across Australia. You can check card balances and buy Westfield gift cards online.`,
      }
    case 'privacy-policy':
      return {
        title: `National Website Privacy Policy | Westfield ${country}`,
        description: `Your privacy is important to us and we are committed to the protection of personal information. Read more on Westfield Australia's website privacy policy here.`,
      }
    case 'terms-and-conditions':
      return {
        title: `National Website Terms & Conditions | Westfield ${country}`,
        description: `We update our site as often as is practicable, but information can change often and we can't guarantee its accuracy at any time. Read more on Westfield Australia's website terms and conditions here.`,
      }
    case 'search':
      return {
        title: `Westfield ${country} - Search Results`,
        description:
          'Westfield is your one-stop destination for shopping, leisure and entertainment. Discover 1000s of popular retailers in fashion, home, decor and more.',
      }
    default:
      return {
        title: `Westfield ${country} - Visit Our Centres or Browse Online`,
        description:
          'Westfield is your one-stop destination for shopping, leisure and entertainment. Discover 1000s of popular retailers in fashion, home, decor and more.',
      }
  }
}
